import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import {
  AddBackgroundRequest,
  DesignRenderGroup,
  DesignTemplateSource,
  DesignTemplateSummary,
  TestRenderRequest,
} from "./dtos";

const DESIGN_TEMPLATE_SERVICE = `${Constants.API_URL}/bedrock/design_templates`;

export class DesignTemplateServices {
  /** Attaches a library asset to the slide version, appended last. */
  @scCatchServiceException(true)
  static async attachBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const request: AddBackgroundRequest = { assetId };
    const { data } = await axios.post<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds`,
      request
    );
    return data;
  }

  @scCatchServiceException(true)
  static async removeBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const { data } = await axios.delete<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds/${assetId}`
    );
    return data;
  }

  /** Admin only: the stored, unhydrated template code of one slide version. */
  @scCatchServiceException(true)
  static async source(templateId: number): Promise<DesignTemplateSource> {
    const { data } = await axios.get<DesignTemplateSource>(`${DESIGN_TEMPLATE_SERVICE}/${templateId}/html`);
    return data;
  }

  /** Admin only: a Darkroom render of edited code as a `draft` group; nothing else changes. */
  @scCatchServiceException(true)
  static async testRender(templateId: number, request: TestRenderRequest): Promise<DesignRenderGroup> {
    const { data } = await axios.post<DesignRenderGroup>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/test_render`,
      request
    );
    return data;
  }

  @scCatchServiceException(true)
  static async setDefaultBackground(templateId: number, assetId: number): Promise<DesignTemplateSummary> {
    const { data } = await axios.put<DesignTemplateSummary>(
      `${DESIGN_TEMPLATE_SERVICE}/${templateId}/backgrounds/default`,
      { assetId }
    );
    return data;
  }
}
